import { Descriptions } from 'antd';
import { useUnit } from 'effector-react';
import style from './AbsoluteInfo.module.css';
import { $absoluteInfoData } from '../../models/absoluteModel/index.js';

function AbsoluteInfo() {
  const absoluteInfoData = useUnit($absoluteInfoData);

  return (
    <div className={style.info_wrapper}>
      <Descriptions items={absoluteInfoData} column={1} />
    </div>
  );
}

export default AbsoluteInfo;
